/**
 * Converts a plural URL segment to the singular entity type used by the backend.
 * e.g. "chapters" → "chapter", "committees" → "committee"
 */
export function toSingular(urlType: string): string {
    if (urlType === "committees") return "committee";
    if (urlType === "chapters") return "chapter";
    if (urlType === "communities") return "community";
    return urlType; // already singular or unknown
}

/**
 * Converts a singular entity type to the plural form used in API endpoint paths.
 * e.g. "chapter" → "chapters", "community" → "communities"
 */
export function toPluralEndpoint(singular: string): string {
    return singular === "community" ? "communities" : `${singular}s`;
}
